/**
 * @author Ariel
 * @description 练习管理
 * @Date 2023/09/20
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";
import { framework_tool, component_tool } from '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;

const _getValue = (type, key) => {
  const values = {
    status: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
  }
  return values[type][key] || ''
}

class PracticeManager extends WizContainer {
  componentName = 'practiceManager';

  constructor(props) {
    super(props);
    this.state = {
      addByTempVisible: false
    }
  };

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'left',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '练习名称',
        field: 'name',
        width: 20,
      },
      {
        headerName: '考试分类',
        field: 'categoryName',
        width: 20,
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
      },
      {
        headerName: '推送时间',
        field: 'pushTime',
        width: 20,
      },
      {
        headerName: '练习状态',
        field: 'status',
        width: 15,
      },
      {
        headerName: '创建人',
        field: 'createFullName',
        width: 20,
      },
      {
        headerName: '练习受众',
        field: 'targetScopeInfo',
        width: 20,
      },
      {
        headerName: '管理权限',
        field: 'managerTargetScopeInfo',
        width: 20
      },
    ]
    if (o['success']) {
      let data = o['data']
      if (data && data instanceof Array && data.length > 0) {
        data.forEach(d => {
          d.status = _getValue("status", d.status)
          d.pushTime = d.pushTime.slice(0,5)
        })
      }
      WizBrowserExport({
        title: '练习信息',
        sheetName: '练习信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '练习信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleExamByTemp(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }
  //选择模版后下一步
  _addExamByTempSubmit = (obj, e) => {
    let examList = [];
    if (obj && obj['valueRows'] && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach(key => {
        let exam = {
          ...key,
          channelType: "temp"
        };
        examList.push(exam)
      });
      if (examList && examList.length) {
        this.jumpPage("push", "/online/practice/add", { ...examList[0] });
      }
    }
    this.setState({
      addByTempVisible: false,
    });
  }
  _onCancel = (e) => {
    this.setState({
      addByTempVisible: false,
    });
  };

  _render() {
    let _templateConfig = templateConfig({
      valueRows: this.valueRows,
      self: this,
      _btnFun: (e) => {
        this.setState({
          addByTempVisible: true
        })
      }
    })

    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        addByTemp: this._handleExamByTemp,
        enable: this._handleCMD,
        del: this._handleCMD,
      }
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateConfig} />
    </>
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PracticeManager);
